import React from "react";
import UINotification from "~/old-ui/UINotification";
import {reverse} from "~/urls";
import {
  LOGIN_ERROR_BAD_REQUEST,
  LOGIN_ERROR_INVALID_CREDENTIALS,
  LOGIN_ERROR_SERVER_UNAVAILABLE,
  LOGIN_ERROR_SERVER_UNEXPECTED_RESPONSE,
  LOGIN_ERROR_TOKEN_EXPIRED,
  LOGIN_ERROR_TOKEN_NOT_FOUND,
  LOGIN_ERROR_SOCIAL_AUTH_FAILED
} from "~/backend";
import ReactLink from "~/components/ReactLink";

const errors = {
  [LOGIN_ERROR_SERVER_UNAVAILABLE]: {
    title: 'Server unavailable',
    text: <span>Sorry, please try again later or contact us by email</span>
  },

  [LOGIN_ERROR_SERVER_UNEXPECTED_RESPONSE]: {
    title: 'Server error!',
    text: (<span>Sorry, please try again later or contact us using email</span>)
  },

  [LOGIN_ERROR_BAD_REQUEST]: {
    title: 'Bad request!',
    text: (<span>Please check again, that you correctly filled form.</span>)
  },

  [LOGIN_ERROR_INVALID_CREDENTIALS]: {
    title: 'Invalid credentials!',
    text: (<span>
      Please check you provide correct email and password
      or <ReactLink to={reverse('reset-password')}>reset your password</ReactLink>
    </span>),
  },

  [LOGIN_ERROR_SOCIAL_AUTH_FAILED]: {
    title: 'Authentication failed',
    text: <span>Your account not found or something else went wrong</span>
  },

  [LOGIN_ERROR_TOKEN_EXPIRED]: {
    title: 'Reset password link expired!',
  },

  [LOGIN_ERROR_TOKEN_NOT_FOUND]: {
    title: 'Reset password link not found!',
  },

  'unknown': {
    title: 'Error!',
    text: (<span>Please double check, that you filled form correctly, then contact us via email</span>),
  }
};

export default function LoginErrorNotification({className, errorCode, closable, onClose}) {
  const error = errors[errorCode] || errors['unknown'];

  return (
    <UINotification
      danger
      className={className}
      closable={closable}
      onClose={onClose}

      title={error.title}
      text={error.text}
    />
  )
}
